
import { mapState, mapMutations, mapActions } from 'vuex'
import DefaultForm from '@pleinair/bigcolony-vue/components/_globals/forms/DefaultForm.vue'

export default {
  name: 'SigninForm',
  components: {
    DefaultForm
  },
  props: {
    provider: {
      type: String,
      default: 'olo',
      validator: (value) => {
        return ['olo', 'spendgo', 'punchh'].includes(value)
      }
    },
    forgotPlacement: {
      type: String,
      default: 'none',
      validator: (value) => {
        return ['none', 'below', 'onElement'].includes(value)
      }
    },
    forgotLanguage: {
      type: String,
      default: 'Forgot Password?',
    },
    signinLanguage: {
      type: String,
      default: 'Sign In'
    },
    appLayout: {
      type: Boolean,
      default: false,
    },
    onSuccess: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    ...mapState([ 'appState' ])
  },
  data() {
    let fields = []
    // Switch email placeholder/label
    let emailPlaceholder = '',
        emailType = '',
        emailValid = ''
    switch(this.provider) {
      case 'spendgo':
        emailPlaceholder = 'Enter your email or phone number'
        emailType = 'text'
        emailValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))|(\d{10})$/
        break
      default:
        emailPlaceholder = 'Enter your email address'
        emailType = 'email'
        emailValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
    // create email field element
    let email = {
      name: 'email',
      label: 'Email Address',
      placeholder: emailPlaceholder,
      autocomplete: 'username',
      type: emailType,
      required: true,
      valid: emailValid,
      errors: {
        invalid: 'Please enter a valid email address.'
      }
    }
    // create password field element
    let password = {
      name: 'password',
      label: 'Password',
      placeholder: 'Enter your password',
      autocomplete: 'current-password',
      type: 'password',
      required: true,
      valid: /^[a-zA-Z0-9\!\@\#\$\%\^\&\*\(\)\{\}]{8,20}$/,
      max: 20,
      errors: {
        invalid: 'Password must be between 8 and 20 characters.'
      }
    }
    switch(this.forgotPlacement) {
      case 'below':
        // add forgot password link as field
        fields.push({
          name: 'forgot',
          label: this.forgotLanguage,
          type: 'link',
          to: this.appLayout ? '/app/forgot' : '/account/forgot'
        })
        break
      case 'onElement':
        // append vaule to password element to show next to password field
        password.forgot = true
        password.to = this.appLayout ? '/app/forgot' : '/account/forgot'
        break
    }
    // populate the fields object
    fields = [email, password].concat(fields)

    return {
      fields,
      message: null
    }
  },
  methods: {
    ...mapMutations([ 'setLoading', 'setErrors' ]),
    ...mapActions([ 'sendRequest', 'trackEvent' ]),
    async submitSignIn(creds) {
      this.setLoading(true)
      let data = creds
      if(this.appState && this.appState.cart_id) {
        data.cart_id = this.appState.cart_id
      } else if(this.cart) {
        data.cart_id = this.cart.id
      }
      // let config = {
      //   method: 'post',
      //   url: 'members/auth',
      //   headers: {
      //     verify: true
      //   },
      //   data
      // }
      // const response = await this.sendRequest(config)
      this.onSuccess(data)
      // if(response.status === 'ok') {
      //   this.trackEvent({ 
      //     name: 'sign_in',
      //     windowObject: window
      //   });
        
      // } else if(response.status === 'validate') {
      //   data.session = response?.data?.session
      //   this.onSuccess(data)
      // } else {
      //   this.setErrors(response.message)
      // }
      this.setLoading(false)
    }
  }
}
